import React, { useState, useEffect } from "react";
import { Table, Select, DatePicker, Space, Button, Input, message, Popover, Menu, Dropdown, Tag } from "antd";
import dayjs from 'dayjs';

import {
  ReloadOutlined,
  DownloadOutlined,
  SearchOutlined,
  PlusCircleOutlined,
  DownOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import moment from "moment";
import { useSelector } from "react-redux";
import "./DataTable.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'; // 👈 Make sure this is the default import
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from 'xlsx';
import { filterList } from "../../data";
import Chat from "../../components/chats/Chat";
// import { getDisplayPharmacy } from "./NewDashboard";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
const { RangePicker } = DatePicker;
const conditionOptions = [
  {
    operator: 'eq',
    item: 'Equal to',
  },
  {
    operator: 'neq',
    item: 'Not Equal to',
  },
  {
    operator: 'lt',
    item: 'Less than',
  },
  {
    operator: 'lte',
    item: 'Less than and equal to',
  },
  {
    operator: 'gt',
    item: 'Greater than',
  },
  {
    operator: 'gte',
    item: 'Greater than and equal to',
  },

];
const MAX_FILTERS = 3;

const DataTable = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
  });
  const [userAccounts, setUserAccounts] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [allUserFetched, setAllUserFetched] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([])
  const [valueInput, setValueInput] = useState(false)
  const [QueryValue, setQueryValue] = useState('')
  const [chatBoxOpen, setChatOpen] = useState(false)

  // Update the initial dateRange state
  // const [dateRange, setDateRange] = useState([
  //   moment("2024-10-01").startOf("day"),
  //   moment("2024-10-31").endOf("day"),
  // ]);
  const { Option, OptGroup } = Select;

  const [fromDate, setFromDate] = useState(() => {
    const now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0));
  });

  const [toDate, setToDate] = useState(() => {
    const now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999));
  });

  const [searchText, setSearchText] = useState("");
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [isDownloading, setDownLoading] = useState(false)
  const SelectedPharmacy = useSelector(state => {
    return state.pharmacyData?.pharmacyData;
  });
  const token = localStorage.getItem("token");
  const userInfo = useSelector((state) => state.userAuth.decodedToken.user);

  const columns = [
    {
      title: "Trans ID",
      dataIndex: "trans_id",
      key: "trans_id",
      sorter: true,
      sorter: (a, b) => {
        return String(a.trans_id).localeCompare(String(b.trans_id));
      },
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return (
          String(record.trans_id).toLowerCase().includes(value.toLowerCase()) ||
          String(record.account_name)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.ndc).toLowerCase().includes(value.toLowerCase()) || String(record?.account_number).toLowerCase().includes(value.toLowerCase())
        );
      },
    },
    {
      title: "Account Number",
      dataIndex: "account_number",
      key: "account_number",
      sorter: true,
      align: "left"
    },
    {
      title: "Account Name",
      dataIndex: "account_name",
      key: "account_name",
      sorter: true,
      align: "center"
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      key: "invoice_number",
      sorter: true,
      align: "center",
      sorter: (a, b) => {
        return String(a.invoice_number).localeCompare(String(b.invoice_number));
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      sorter: true,
      render: (text) => moment.utc(text).format('MM-DD-YYYY HH:mm:ss'),
      align: "center"
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    },
    {
      title: "NDC", dataIndex: "ndc", key: "ndc", sorter: true,
      align: "center",
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val
    },
    {
      title: "UPC", dataIndex: "upc", key: "upc", sorter: true,
      align: "center",
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val
    },
    {
      title: "Quantity Sold",
      dataIndex: "quantity_sold",
      key: "quantity_sold",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "right"
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      key: "unit_price",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right"
    },
    {
      title: "Unit of Measure",
      dataIndex: "unit_of_measure",
      key: "unit_of_measure",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    },
    {
      title: "Extended Price",
      dataIndex: "extended_price",
      key: "extended_price",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right"
    },
    {
      title: "Item Description",
      dataIndex: "item_description",
      key: "item_description",
      sorter: true,
      align: "left",
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    },
    {
      title: "Generic Size Qty",
      dataIndex: "generic_size_qty",
      key: "generic_size_qty",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "right"
    }, {
      title: "Brand Size Qty",
      dataIndex: "brand_size_qty",
      key: "brand_size_qty",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "right"
    }, {
      title: "Generic Drug Strength",
      dataIndex: "generic_drug_strength",
      key: "generic_drug_strength",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Generic Dose Form",
      dataIndex: "generic_dose_form",
      key: "generic_dose_form",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "left"
    }, {
      title: "Package Size",
      dataIndex: "package_size",
      key: "package_size",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "right"
    }, {
      title: "Generic yn",
      dataIndex: "generic_yn",
      key: "generic_yn",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Drop Ship yn",
      dataIndex: "drop_ship_yn",
      key: "drop_ship_yn",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    },

    {
      title: "Rx Code",
      dataIndex: "rx_code",
      key: "rx_code",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Rebate Eligible",
      dataIndex: "rebate eligible",
      key: "rebate eligible",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Specialty YN",
      dataIndex: "specialty_yn",
      key: "specialty_yn",
      sorter: true,
      render: (value) => value ? "Yes" : "No",
      align: "center"
    },

    {
      title: "GLP1",
      dataIndex: "GLP1",
      key: "GLP1",
      sorter: true,
      align: "center",
      render: (value) => {
        if (value === "Y") return "Yes";
        if (value === "N") return "No";
        return ""; // for null/undefined
      },
    },

    {
      title: "Specialty Class",
      dataIndex: "specialty_class",
      key: "specialty_class",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "One Stop YN",
      dataIndex: "one_stop_yn",
      key: "one_stop_yn",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Rtl 2 YN",
      dataIndex: "rtl_2_yn",
      key: "rtl_2_yn",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Dc Fill Id",
      dataIndex: "dc_fill_id",
      key: "dc_fill_id",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "right"
    },


    {
      title: "Generic Sales",
      dataIndex: "generic_sales",
      key: "generic_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right"
    }, {
      title: "Generic Rx Sales",
      dataIndex: "generic_rx_sales",
      key: "generic_rx_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Rx Sales",
      dataIndex: "rx_sales",
      key: "rx_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Otc Sales",
      dataIndex: "otc_sales",
      key: "otc_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Brand Rx Sales",
      dataIndex: "brand_rx_sales",
      key: "brand_rx_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Brand Sales",
      dataIndex: "brand_sales",
      key: "brand_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Return Sales",
      dataIndex: "return_sales",
      key: "return_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Specialty Sales",
      dataIndex: "specialty_sales",
      key: "specialty_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Hiv Sales",
      dataIndex: "hiv_sales",
      key: "hiv_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Biologics YN",
      dataIndex: "biologics_yn",
      key: "biologics_yn",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    }, {
      title: "Biologics Sales",
      dataIndex: "biologics_sales",
      key: "biologics_sales",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    }, {
      title: "Estimated Rebate",
      dataIndex: "estimated_rebate",
      key: "estimated_rebate",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val?.toFixed(2),
      align: "right",
    },
    // {
    //   title: "Brand Rebate Percentage",
    //   dataIndex: "brand_rebate_percentage",
    //   key: "brand_rebate_percentage",
    //   sorter: true,
    // },{
    //   title: "Generic Rebate Percentage",
    //   dataIndex: "generic_rebate_percentage",
    //   key: "generic_rebate_percentage",
    //   sorter: true,
    // },
    {
      title: "Include YN",
      dataIndex: "include_yn",
      key: "include_yn",
      sorter: true,
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
    },
    {
      title: "Mckesson Specialty CD",
      dataIndex: "mckesson_specialty_cd",
      key: "mckesson_specialty_cd",
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
      // sorter: true,
    },
    {
      title: "Mckesson Covid FLU",
      dataIndex: "mckesson_covid_flu_flag",
      key: "mckesson_covid_flu_flag",
      render: (val) =>
        val === undefined || val === "" || val === null ? "-" : val,
      align: "center"
      // sorter: true,
    },
  ];
  const updatePharmacies = (value) => {
    setSelectedAccounts(value);
  };

  function formatDate(date) {
    const d = new Date(date);
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }


  useEffect(() => {
    const fetchUserAccounts = async () => {
      const formattedFromDate = formatDate(fromDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);
      try {
        const response = await axiosInstance.get(
          `/${apiVersion}users/accounts?email=${userInfo?.email}`,
          // {
          //   headers: {
          //     "Content-Type": "application/json",
          //     authorization: `Bearer ${token}`,
          //   },
          // }
        );
        // console.log("response", response.data.data.data);
        setUserAccounts(response.data.data.data);
        setAllUserFetched(true)
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchUserAccounts();
  }, []);

  useEffect(() => {
    if (!allUserFetched) return; // wait for fetch
    if (userAccounts.length > 0 && selectedAccounts?.length === 0) {
      const specialUser = userAccounts.find(user => user.acct_id === 96167);
      if (SelectedPharmacy) {
        setSelectedAccounts(SelectedPharmacy)
      } else if (specialUser) {
        setSelectedAccounts([specialUser?.acct_id]);
      } else {
        setSelectedAccounts([userAccounts[0]?.acct_id]);
      }
    }
  }, [userAccounts, selectedAccounts, allUserFetched]);


  const getApiVersionByDate = (date) => {
    if (!date) return "";
    const sep2025 = new Date("2025-09-01");
    const selectedDate = new Date(date);

    return selectedDate < sep2025 ? "" : "";
  };

  const fetchData = async (params = {}) => {
    setLoading(true);
    try {
      const formattedFromDate = formatDate(fromDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);
      const currentPage = params.current || pagination.current;
      const pageSize = params.pageSize || pagination.pageSize;

      const response = await axiosInstance.get(`/${apiVersion}users/gcr`, {
        params: {
          FromDate: formatDate(fromDate), // → "2024-10-01"
          ThruDate: formatDate(toDate),   // → "2024-10-31"
          store_id: selectedAccounts.join(","),
          skip: (currentPage - 1) * pageSize,
          take: pageSize,
        },
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });
      // console.log("response in usergcr", response);

      // setData(response.data);
      // setPagination({
      //   ...pagination,
      //   total: response.data,
      // });

      const fetchedData = response.data;
      setData(fetchedData);
      setPagination({
        current: currentPage,
        pageSize: pageSize,
        total:
          fetchedData.length < pageSize
            ? (currentPage - 1) * pageSize + fetchedData.length
            : currentPage * pageSize + 1,
      });

    } catch (error) {
      message.error("Failed to fetch data");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (fromDate && toDate && selectedAccounts?.length > 0) {
      fetchData();
    }
  }, [selectedAccounts, toDate, fromDate]);

  const handleTableChange = (newPagination, filters, sorter) => {
    if (selectedFilter?.length > 0) {
      fetchDatatwo(null, {
        ...newPagination,
        sortField: sorter.field,
        sortOrder: sorter.order,
      })
    } else {
      fetchData({
        ...newPagination,
        sortField: sorter.field,
        sortOrder: sorter.order,
      });
    }
  };

  const handleExport = async () => {
    try {
      setDownLoading(true);
      const formattedFromDate = formatDate(fromDate);
      const apiVersion = getApiVersionByDate(formattedFromDate);

      const response = await axiosInstance.get(`/${apiVersion}users/gcr`, {
        params: {
          FromDate: formatDate(fromDate),
          ThruDate: formatDate(toDate),
          store_id: selectedAccounts.join(","),
          skip: 0,           // start from beginning
          take: 1000000,      // large number to fetch all records
        },
      });

      const exportData = response.data;
      const headers = [
        "RowNum",
        "Account Number",
        "Account Name",
        "Invoice Number",
        "Invoice Date",
        "Po Number",
        "NDC",
        "UPC",
        "Quantity Sold",
        "Unit Price",
        "Unit Of Measure",
        "Extended Price",
        "Item Description",
        "SKU",
        "Drop Ship yn",
        "Brand Size Qty",
        "Generic Drug Strength",
        "Generic Size Qty",
        "Package Size",
        "Rx Code",
        "Generic Dose Form",
        "Generic YN",
        "Specialty YN",
        "GLP1",
        "One Stop YN",
        "Rtl 2 YN",
        "Dc Fill Id",
        "Generic Sales",
        "Generic Rx Sales",
        "Rx Sales",
        "Otc Sales",
        "Brand Rx Sales",
        "Brand Sales",
        "Return Sales",
        "Specialty Sales",
        "Hiv Sales",
        "Biologics Yn",
        "Biologics Sales",
        "Estimated Rebate",
        "Include YN",
        "Mckesson Specialty CD",
        "Mckesson Covid FLU"
      ];

      const rows = exportData.map((item) => [
        item?.RowNum,
        item?.account_number,
        item?.account_name,
        item?.invoice_number,
        item?.invoice_date,
        item?.po_number,
        item?.ndc,
        item?.upc,
        item?.quantity_sold,
        `$ ${item?.unit_price}`,
        item?.unit_of_measure,
        `$ ${item?.extended_price}`,
        item?.item_description,
        item?.sku,
        item?.drop_ship_yn,
        item?.brand_size_qty,
        item?.generic_drug_strength,
        item?.generic_size_qty,
        item?.package_size,
        item?.rx_code,
        item?.generic_dose_form,
        item?.generic_yn,
        item?.specialty_yn,
        item?.GLP1,
        item?.one_stop_yn,
        item?.rtl_2_yn,
        item?.dc_fill_id,
        item?.generic_sales,
        item?.generic_rx_sales,
        item?.rx_sales,
        item?.otc_sales,
        item?.brand_rx_sales,
        item?.brand_sales,
        item?.return_sales,
        item?.specialty_sales,
        item?.hiv_sales,
        item?.biologics_yn,
        item?.biologics_sales,
        item?.estimated_rebate,
        item?.include_yn,
        item?.mckesson_specialty_cd,
        item?.mckesson_covid_flu_flag
      ]);

      // Combine headers and data
      const worksheetData = [headers, ...rows];

      // Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "pharmacy_report");

      // Export the Excel file
      XLSX.writeFile(workbook, "pharmacy_report.xlsx");
    } catch (error) {
      message.error("Failed to export data");
      console.error("Export error:", error);
    } finally {
      setLoading(false);
      setDownLoading(false)
    }
  };


  const generateKey = (column, value) => `${column}__${value}`;
  const renderMenu = () => (
    <Menu style={{
      maxHeight: 300, overflowY: "auto",
      //  minWidth: 150,
      left: -20
    }}
      className="w-[150px] md:w-[220px]">
      {filterList.map((column) => {
        const selectedtitle = selectedFilter.some((f) => f.column === column?.column);
        return (
          <Menu.SubMenu key={column?.column} title={column?.title}
            style={{
              backgroundColor: selectedtitle ? "#e6f7ff" : undefined,
              fontWeight: selectedtitle ? 600 : "normal"
            }}
          >
            {conditionOptions.map((option) => {
              const key = generateKey(column?.column, option?.operator);
              const isSelected = selectedFilter.some((f) => ((`${f?.column}__${f?.operator}`) === key));
              return (
                <Menu.Item
                  key={key}
                  onClick={() => {
                    if (valueInput) {
                      message.info('Kindly First Enter Value')
                    } else {
                      handleToggleSelect(column?.column, option?.operator)
                    }
                  }
                  }
                  className="w-[150px] md:w-[220px]"
                  style={{
                    backgroundColor: isSelected ? "#e6f7ff" : undefined,
                    fontWeight: isSelected ? 600 : "normal",
                    // width: 150,
                  }}
                >
                  {option?.item}
                </Menu.Item>
              );
            })}
          </Menu.SubMenu>
        )
      })}
    </Menu>
  );
  const handleToggleSelect = (column, value) => {
    const key = generateKey(column, value);
    const exists = selectedFilter.some((f) => ((`${f?.column}__${f?.operator}`) === key));
    const sameColumnExists = selectedFilter.some((f) => f.column === column);
    if (!exists && selectedFilter?.length >= MAX_FILTERS) {
      message.info('Max 3 Filters Allowed')
      return;
    }
    let updatedFilters;

    if (exists) {
      updatedFilters = selectedFilter.filter(
        (f) => `${f.column}__${f.operator}` !== key
      );
      fetchDatatwo(updatedFilters);
    } else if (sameColumnExists) {
      updatedFilters = selectedFilter.map((f) =>
        f.column === column ? { column, operator: value, } : f
      );
      setValueInput(true)
    } else {
      updatedFilters = [...selectedFilter, { column, operator: value, }];
      setValueInput(true)
    }
    setSelectedFilter(updatedFilters);
  };

  useEffect(() => {
    if (selectedFilter.length > 0) {
      // fetchDatatwo();
      // setValueInput(true)
    }
  }, [selectedFilter]);
  const fetchDatatwo = async (updatedFilters, params = {},) => {
    // console.log(updatedFilters, "updatedFiltersupdatedFiltersupdatedFilters")
    setLoading(true);
    try {
      const currentPage = params.current || pagination.current;
      const pageSize = params.pageSize || pagination.pageSize;
      const payload = {
        FromDate: fromDate.toISOString().split("T")[0], // → "2024-10-01"
        ThruDate: toDate.toISOString().split("T")[0],   // → "2024-10-31"
        store_id: selectedAccounts.join(","),
        skip: (currentPage - 1) * pageSize,
        take: pageSize,
        filter: updatedFilters ? updatedFilters : selectedFilter
      };

      const response = await axiosInstance.post(`/users/gcr/raw`, payload,
      );
      // console.log("response in usergcr", response);
      const fetchedData = response.data;
      setData(fetchedData);
      setPagination({
        current: currentPage,
        pageSize: pageSize,
        total:
          fetchedData.length < pageSize
            ? (currentPage - 1) * pageSize + fetchedData.length
            : currentPage * pageSize + 1,
      });

    } catch (error) {
      message.error("Failed to fetch data");
      console.error("Error:", error);
      setSelectedFilter((prev) => prev.slice(0, -1));
    } finally {
      setLoading(false);
    }
  };

  const handleINput = () => {
    // console.log(QueryValue, "QueryValue222222222222222")
    if (!QueryValue) {
      message.info('Kindly Enter Value');
      return;
    }
    const updatedFilters = selectedFilter.map((f, index) => {
      if (f.value === undefined || f.value === null || f.value === '') {
        return { ...f, value: QueryValue };
      }
      return f;
    });

    setSelectedFilter(updatedFilters);
    // console.log(updatedFilters, "updatefilterssssss")
    setValueInput(false)
    setQueryValue('')
    fetchDatatwo(updatedFilters);
  }

  const getDisplayPharmacy = (account) => {
    const isGoodUser = userInfo?.user_roles_id === 5;

    if (isGoodUser && account?.acct_id === 96167) {
      return {
        ...account,
        displayName: "ABC Pharmacy",
        displayId: "123456",
      };
    }
    return {
      ...account,
      displayId: account.acct_id,
      displayName: account.name || account.label,
    };
  };
  return (
    <>
      <HeaderCompo initialColor={'#000833'} />
      <div className="p-6" style={{ padding: "16px 16px 0 16px" }}>
        <div className="mb-1">
          <h1 className="text-2xl font-bold mb-4">Transaction Data</h1>
          <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 mb-4">
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 w-full md:w-auto">
              <Select
                mode="multiple"
                value={selectedAccounts}
                onChange={updatePharmacies}
                className="w-full md:w-[400px] "
                style={{
                  // width: "400px",
                  border: "1px solid #d9d9d9",
                  "border-radius": "6px",
                }}
                placeholder="Select accounts"
                options={userAccounts?.map((account) => {
                  // label: account.name || account.label,
                  // value: account.acct_id || account.acct_id,
                  // key: account.acct_id,
                  const modified = getDisplayPharmacy(account);
                  return {
                    label: `${modified.displayName} (${modified.displayId || account.acct_id})`,
                    value: account.acct_id,
                    key: account.acct_id,
                    displayId: modified.displayId,
                  };
                })}
                showSearch
                // filterOption={(input, option) => {
                //   const label = (option?.label ?? "").toString().toLowerCase();
                //   const value = (option?.value ?? "").toString().toLowerCase();
                //   return (
                //     label.includes(input.toLowerCase()) ||
                //     value.includes(input.toLowerCase())
                //   );
                // }
                //   // (option?.label ?? "")
                //   //   .toLowerCase()
                //   //   .includes(input.toLowerCase())
                // }
                filterOption={(input, option) => {
                  const search = input.toLowerCase();
                  const label = (option?.label ?? "").toString().toLowerCase();
                  const value = (option?.value ?? "").toString().toLowerCase();
                  const displayId = (option?.displayId ?? "").toString().toLowerCase();
                  return (
                    label.includes(search) ||
                    displayId.includes(search) || // allows search by 123456
                    value.includes(search)        // fallback (96167 if needed)
                  );
                }}

                maxTagCount={3}
              />
            </div>
            <div className="flex md:m-0 w-full">
              <div className="flex gap-1 w-full md:justify-center align-middle justify-start mr-4">
                <span className="font-medium text-gray-600">From</span>
                <DatePicker
                  placeholder="From Date"
                  value={fromDate ? dayjs.utc(fromDate) : null}
                  disabledDate={(current) =>
                    current && current > dayjs().add(1, "day").endOf("day")
                  }
                  onChange={(date) => {
                    if (date) {
                      const utcDate = new Date(Date.UTC(date.year(), date.month(), date.date(), 0, 0, 0, 0));
                      setFromDate(utcDate);
                    }
                    // if (date) {
                    //   const jsDate = new Date(date.toDate());
                    //   jsDate.setHours(0, 0, 0, 0);
                    //   setFromDate(jsDate);
                    // }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full "
                />
              </div>
              <div className="flex flex-row w-full gap-1 justify-center align-middle">
                <span className=" font-medium text-gray-600">To</span>

                <DatePicker
                  placeholder="To Date"
                  value={toDate ? dayjs.utc(toDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const utcDate = new Date(Date.UTC(date.year(), date.month(), date.date(), 23, 59, 59, 999));
                      setToDate(utcDate);
                    }
                    // if (date) {
                    //   const jsDate = new Date(date.toDate());
                    //   jsDate.setHours(23, 59, 59, 999);
                    //   setToDate(jsDate);
                    // }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full "
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 w-full  md:w-auto">
              <div className="w-full md:w-[200px]">
                <Input
                  placeholder="Search..."
                  prefix={<SearchOutlined />}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)" }}
                // className="w-full"

                />
              </div>
              <div className="gap-2 flex flex-row md:justify-between justify-start w-full md:w-auto">
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => fetchData(pagination)}
                  className=" w-full md:w-[100px]"
                >
                  Refresh
                </Button>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={handleExport}
                  className="w-full md:w-[100px]  md:mt-0"
                  loading={isDownloading}
                >
                  Export
                </Button>
              </div>
            </div>
          </div>


          {
            userInfo?.user_roles_id == 5 && valueInput ? (
              <div style={{ marginTop: '10px', padding: '10px 14px', borderRadius: '8px', fontSize: '14px' }}>
                {(() => {
                  const lastFilter = selectedFilter[selectedFilter.length - 1];
                  const matched = filterList.find(f => f.column === lastFilter?.column);
                  const matchedFilterName = filterList.find(item => item.column === lastFilter?.column);
                  const matchedCondition = conditionOptions.find(opt => opt.operator === lastFilter?.operator);
                  return (
                    <span style={{ fontWeight: '500', color: "#222" }}>
                      Selected : {matchedFilterName?.title || lastFilter?.column} &nbsp;→&nbsp; {matchedCondition?.item || lastFilter?.operator}
                    </span>
                  );
                })()}
              </div>
            ) : null
          }


          {
            userInfo?.user_roles_id == 5 ?
              <div className="flex flex-col md:flex-row items-start md:items-center gap-2">
                <div className="flex items-center gap-2 ">
                  <PlusCircleOutlined className="cursor-pointer " style={{ color: "blue" }} />
                  <div >
                    <Dropdown overlay={renderMenu()} trigger={["click"]} style={{ Width: "100%" }}>
                      <Button className="w-full">
                        {selectedFilter.length > 0
                          ? `${selectedFilter.length} Filters Selected`
                          : "Select Filters"}{" "}
                        <DownOutlined />
                      </Button>
                    </Dropdown>

                  </div>
                </div>
                {
                  valueInput ?
                    <div className="w-full md:w-[300px] gap-2 flex">
                      <Input
                        // placeholder={''}
                        style={{
                          border: "1px solid var(--Primary-Dark-Blue, #000833)",
                          height: "34px",
                          width: "70%"
                        }}
                        onChange={(e) => setQueryValue(e.target.value)}
                        // prefix={<MailOutlined />}
                        // readOnly={!isNewRecord}
                        placeholder="Enter Value"
                      />
                      <Button
                        type="primary"
                        // icon={<DownloadOutlined />}
                        onClick={handleINput}
                        className="w-[100px] md:w-[100px]  md:mt-0"
                      >
                        Submit
                      </Button>
                    </div>
                    : null
                }
              </div>
              : null
          }
        </div>

        {/*       {
          selectedFilter?.length > 0 ?
            <div
              style={{
                // marginTop: 16,
                display: "flex",
                flexWrap: "wrap",
                gap: 12,
                padding: "8px 0",
              }}
            >
              {(valueInput
                ? selectedFilter.slice(0, -1) // second last element only
                : selectedFilter
              ).map((filter) => {
                const matchedFilter = filterList.find(f => f.column === filter.column);
                const title = matchedFilter?.title || filter.column;

                return (
                  <Tag
                    key={filter.key}
                    style={{
                      fontSize: 14,
                      padding: "6px 12px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: 20,
                      display: "flex",
                      alignItems: "center",
                    }}
                    closable
                    onClose={(e) => {
                      e.preventDefault();
                      setSelectedFilter((prev) => {
                        const updated = Array.isArray(prev)
                          ? prev.filter(
                            (f) =>
                              !(
                                f.column === filter.column &&
                                f.value === filter.value &&
                                f.operator === filter.operator
                              )
                          )
                          : [];

                        // 🔥 Trigger fetchDataTwo with updated filter
                        fetchDatatwo(updated);
                        return updated;
                      });
                    }
                    }
                  >
                    <span style={{ fontWeight: 500 }}>
                      {title}
                    </span>

                  </Tag>
                );
              })}
            </div>
            : null
        } */}

        {
          (selectedFilter?.length > 0 && !(selectedFilter?.length == 1 && valueInput)) ? (
            <div style={{ padding: 0 }}>
              <Table
                // size="small"
                bordered
                pagination={false}
                className="custom-table user-tbl filter-table"
                scroll={{ x: "max-content" }}
                size="middle"
                dataSource={
                  valueInput ? selectedFilter.slice(0, -1) : selectedFilter
                }
                rowKey="key"
                columns={selectedFilter?.length == 1 && valueInput ? null : [
                  {
                    title: 'Column',
                    dataIndex: 'column',
                    // sorter :true,
                    key: 'column',
                    align: "left",
                    render: (column) => {
                      const matched = filterList.find(f => f.column === column);
                      return matched?.title || column;
                    },
                  },
                  {
                    title: 'Operator',
                    dataIndex: 'operator',
                    key: 'operator',
                    align: "left",

                  },
                  {
                    title: 'Value',
                    dataIndex: 'value',
                    key: 'value',
                    align: "left",

                  },
                  {
                    title: 'Action',
                    key: 'action',
                    align: "left",

                    render: (_, filter) => (
                      <Button
                        danger
                        size="small"
                        style={{ padding: '0 4px', height: '24px', fontSize: '13px' }}
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedFilter((prev) => {
                            const updated = Array.isArray(prev)
                              ? prev.filter(
                                (f) =>
                                  !(
                                    f.column === filter.column &&
                                    f.value === filter.value &&
                                    f.operator === filter.operator
                                  )
                              )
                              : [];
                            fetchDatatwo(updated);
                            return updated;
                          });
                        }}
                      >
                        Remove
                      </Button>
                    ),
                  },
                ]}
              />
            </div>
          ) : null
        }

        <Table
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          loading={loading}
          scroll={{ x: "max-content" }}
          rowKey="trans_id"
          size="middle"
          className="custom-table user-tbl"
        />
        {/* {userInfo?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
        <div className="chat-button" onClick={() => setChatOpen(true)}>
          💬 Let’s Chat
        </div>
      )}
      <Chat
              open={chatBoxOpen}
              setOpen={setChatOpen}
            /> */}
      </div>
    </>
  );
};

export default DataTable;
